import { styled, css } from '@mui/material';

export const StyledNavMenuSelectCustomerContainer = styled('div')(
  ({ theme, contractEnded }) => css`
    align-items: center;
    column-gap: ${theme.spacing('LARGE')};
    display: flex;
    justify-content: flex-start;
    opacity: ${contractEnded ? 0.6 : 1};
    padding: ${theme.spacing('MEDIUM')};
    width: 100%;
  `
);

export const StyledNavMenuSelectCustomerPolicyLogo = styled('img')(
  ({ theme }) => css`
    height: ${theme.spacing('3XL')};
    width: ${theme.spacing('3XL')};
  `
);

export const StyledNavMenuSelectCustomerTextContent = styled('div')`
  flex-grow: 1;
`;

export const StyledNavMenuCurrentlySelectedCustomerIcon = styled('div')(
  ({ theme }) => css`
    align-items: center;
    display: flex;
    height: ${theme.spacing('1XL')};
    width: ${theme.spacing('1XL')};

    svg {
      height: fit-content;
      width: fit-content;
    }
  `
);
